import { render, staticRenderFns } from "./MarketArticle.vue?vue&type=template&id=8872c364&scoped=true&"
import script from "./MarketArticle.vue?vue&type=script&lang=js&"
export * from "./MarketArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8872c364",
  null
  
)

export default component.exports